import { render, staticRenderFns } from "./_providerWinLoseCompany.vue?vue&type=template&id=2cc99491&lang=pug"
import script from "./_providerWinLoseCompany.vue?vue&type=script&lang=js"
export * from "./_providerWinLoseCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports